import { useTranslation } from 'react-i18next';

import styleSheet from '../../../teamSelector/styles/teamSelector.module.scss';

import SignInIcon from '../icons/SignInIcon';
import RefreshIcon from '../icons/RefreshIcon';
const styles = styleSheet.locals || {};
/**
 * SignInGate component
 *
 * @param {object} props props
 * @returns {Function} <SignInGate />
 */
function SignInGate() {
    const { t } = useTranslation();

    const handleRefreshClick = () => {
        window.location.reload();
    };

    const signInMessage = t('signInGate.signInTeamSelector');

    return (
        <div className={styles.teamSelectorGate}>
            <div className={styles.teamSelectorGateText}>
                <div className={styles.teamSelectorGateIcon}>
                    <SignInIcon />
                </div>

                <div className={styles.teamSelectorGateTitle}>
                    {signInMessage}
                </div>

                <div className={styles.teamSelectorGateSubtitle}>
                    {t('signInGate.alreadySignedIn')}
                    <div
                        onClick={handleRefreshClick}
                        className={styles.teamSelectorGateRefreshWrapper}
                    >
                        <span className={styles.teamSelectorGateRefresh}>
                            {t('signInGate.refreshBrowser')}
                        </span>
                        <span className={styles.teamSelectorGateRefreshIcon}>
                            <RefreshIcon />
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default SignInGate;
